import React from 'react';
import PropTypes from 'prop-types';

import renderOptions from './options-renderer';

const OptionGroup = ({ className, id, label, options }) => <optgroup className={className} label={label}>
    {renderOptions(options)}
  </optgroup>

export default OptionGroup;

OptionGroup.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      optgroup: PropTypes.shape({
        className: PropTypes.string,
        label: PropTypes.string.isRequired,
        options: PropTypes.arrayOf(PropTypes.shape({})),
      }),
      renderer: PropTypes.func,
      text: PropTypes.string.isRequired,
      value: PropTypes.string,
    })
  ),
};

OptionGroup.defaultProps = {
  className: '',
  options: [],
};
